import colors from './colors';
import config from './config';
import locales from './locales';
import www from './www';

export { colors, config, locales, www };
